import {
  SAVE_SUBLIMIC_USER_SURVEY,
  SAVE_SUBLIMIC_STYLIST_DIAGNOSIS,
  RESET_SUBLIMIC_DIAGNOSIS,
  SAVE_SUBLIMIT_USER_DATA
} from '../constants';
import { getSCUserDiagnosis } from '../../services/api';

export const saveSublimicUserSurvey = data => ({
  type: SAVE_SUBLIMIC_USER_SURVEY,
  payload: data,
});

export const saveSublimicStylistDiagnosis = data => ({
  type: SAVE_SUBLIMIC_STYLIST_DIAGNOSIS,
  payload: data,
});

export const resetSublimicDiagnosis = () => ({
  type: RESET_SUBLIMIC_DIAGNOSIS,
});

export const saveSublimicUserData = data => ({
  type: SAVE_SUBLIMIT_USER_DATA,
  payload: data,
});

export const fetchSCUserDiagnosis = id => ({
  type: SAVE_SUBLIMIT_USER_DATA,
  payload: getSCUserDiagnosis(id),
});



// WEBPACK FOOTER //
// ./src/redux/actions/sublimicDiagnosis.js